import { lazy, Suspense } from 'preact/compat';
import { FunctionalComponent } from 'preact';
// import { useEffect, useState } from 'preact/hooks';
import { useDispatch, useSelector } from 'react-redux';

import { createNewTab } from '../../../../shared/chromeApi';
// import threeDotsIcon from '../../../../public/img/three-dots-vertical.svg';
import {
  // toggleBookmarksNotification,
  setBookmarksTooltip,
  selectBookmarksTooltipShown,
  // selectOnboardingStep,
  // selectTotalShellsCounter,
  // selectBookmarksDiscovered,
} from '../slice';

// import RippleDot from '../../../shared/RippleDot';
import styles from './styles.module.scss';
// import { GlobalState } from '../../../types.global';
// import { selectFeatureFlags } from '../../../store/selectors';

const InfoPopover = lazy(() => import('./components/InfoPopover'));
// const MorePopover = lazy(() => import('./components/MorePopover'));

export const getIsBookmarksHidden = (): boolean =>
  typeof window === 'undefined' ||
  window.outerHeight - window.innerHeight <= 90;

const Bookmarks: FunctionalComponent = () => {
  const dispatch = useDispatch();
  // const [showMoreButton, setShowMoreButton] = useState(false);
  // const [showMorePopover, setShowMorePopover] = useState(false);

  // const [isHidden, setHidden] = useState(false);

  // const featureFlags = useSelector(selectFeatureFlags);
  const showBookmarksTooltip = useSelector(selectBookmarksTooltipShown);
  // const isOnboardingOn = !!useSelector(selectOnboardingStep);
  // const shellsCounter = useSelector(selectTotalShellsCounter);
  // const bookmarksDiscovered = useSelector(selectBookmarksDiscovered);

  const handleCloseInfoPopover = () => {
    dispatch(setBookmarksTooltip(false));
  };

  const handleBookmarksClick = () => {
    createNewTab('chrome://bookmarks/').catch(console.error);
  };

  // const handleMore = (payload) => {
  //   setShowMoreButton(payload);
  //   setShowMorePopover(payload);
  // };

  const onBookmarksHoverLite = () => {
    if (!getIsBookmarksHidden()) return;

    if (!showBookmarksTooltip && showBookmarksTooltip !== false) {
      dispatch(setBookmarksTooltip(true));
      return;
    }
  }

  const onBookmarksHover = () => {
    dispatch(setBookmarksTooltip(true));
  };

  // const handleClickMoreButton = () => {
  //   if (!showMorePopover) {
  //     handleCloseInfoPopover();
  //     handleMore(true);
  //   }
  // };

  const handleOnMouseLeave = () => {
    // if (showMoreButton && !showMorePopover) setShowMoreButton(false);
    // if (!showBookmarksTooltip && showBookmarksTooltip !== true) {
    dispatch(setBookmarksTooltip(false));
    // return;
    // }
  };

  // const handleShowInfoPopover = () => {
  //   handleMore(false);
  //   dispatch(setBookmarksTooltip(true));
  // };

  // useEffect(() => {
  //   const listener = (e) => {
  //     if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.code === 'KeyB') {
  //       setTimeout(() => {
  //         setHidden(getIsBookmarksHidden());
  //       }, 500);
  //     }
  //   };
  //   window.addEventListener('keydown', listener);
  //   return () => {
  //     window.removeEventListener('keydown', listener);
  //   };
  // }, []);

  // if (isHidden) return null;

  return (
    <div
      onMouseEnter={process.env.APP_PLATFORM === 'web' ? onBookmarksHover : (process.env.APP_TYPE === 'lite' ? onBookmarksHoverLite : onBookmarksHover)}
      onMouseLeave={process.env.APP_PLATFORM === 'web' ? handleOnMouseLeave : (process.env.APP_TYPE !== 'lite' ? handleOnMouseLeave : null)}
      className={styles.bookmarksWrapper}
    >
      {/*{!bookmarksDiscovered && !isOnboardingOn && shellsCounter < 200 && (*/}
      {/*  <RippleDot />*/}
      {/*)}*/}
      <div onClick={handleBookmarksClick} className={styles.bookmarksButton}>
        Bookmarks
      </div>

      {/*{showMoreButton && (*/}
      {/*  <div onClick={handleClickMoreButton} className={styles.moreCircle}>*/}
      {/*    <img src={threeDotsIcon} className={styles.threeDots} alt="" />*/}
      {/*  </div>*/}
      {/*)}*/}

      {/*{showMorePopover && (*/}
      {/*  <Suspense fallback={null}>*/}
      {/*    <MorePopover*/}
      {/*      featureFlags={featureFlags}*/}
      {/*      hideBookmarks={() => dispatch(toggleBookmarksNotification(true))}*/}
      {/*      handleShowInfoPopover={handleShowInfoPopover}*/}
      {/*      onLeave={() => handleMore(false)}*/}
      {/*    />*/}
      {/*  </Suspense>*/}
      {/*)}*/}

      {showBookmarksTooltip && (
        <Suspense fallback={null}>
          <InfoPopover onClose={handleCloseInfoPopover} />
        </Suspense>
      )}
    </div>
  );
};

export default Bookmarks;
